import { createContext } from 'react';

const areaAnalysisContext = createContext();

export default areaAnalysisContext;